import { reactive, computed, onBeforeMount, ref, watch } from '@vue/composition-api'
import * as apiBookmark from '@/api/bookmark'
import * as apiKnowledge from '@/api/knowledge'
import * as apiCommon from '@/api/common'
import * as apiSearchCondition from '@/api/search-condition'
import { formatDate } from '@/util/common'
import * as _ from 'lodash'
import { SCROLL_INTERVAL_DELAY, SCROLL_INTERVAL_MAX_COUNT } from '@/util/constants'
import { searchByKeyword, getSearchText, getIsFuzzy } from '@/util/search'

export const KnowledgeList = (props, context) => {
  const store = context.root.$store
  const router = context.root.$router
  const { knowledge } = store.state

  onBeforeMount(async () => {

    // 検索カテゴリを設定
    store.dispatch('search/setSearchCategory', 'knowledge')

    // キーワードの同期用にストアから取り出し
    preState.keyword = getSearchText(group1.searchCategory)
    preState.is_fuzzy = getIsFuzzy(group1.searchCategory)

    const otherScreenSearchParams = store.getters['search/getKnowledgeSearchParam']
    if (Object.keys(otherScreenSearchParams).length > 0) {
      await store.dispatch('knowledge/resetAllState')
      preState.search_date_start = otherScreenSearchParams.search_date_start ?? null
      preState.search_date_end = otherScreenSearchParams.search_date_end ?? null
      preState.is_fuzzy = otherScreenSearchParams.is_fuzzy ?? 0
      preState.keyword = otherScreenSearchParams.keyword ?? ''
      store.dispatch('knowledge/setSearchValue', otherScreenSearchParams)
      otherScreenSearchParams.category && await store.dispatch('knowledge/preSetCategory', otherScreenSearchParams.category)
      // 条件を設定した上でリスト取得
      store.dispatch('knowledge/getKnowledgeLists')
      // カテゴリ取得時にカテゴリのチェックを初期化するため、取得後にチェックするカテゴリを再設定
      store
        .dispatch('knowledge/getCategories')
        .finally(() => {
          store.dispatch('knowledge/preSetCategory', otherScreenSearchParams.category)
          store.dispatch('search/resetKnowledge')
        })
    } else {
      store.dispatch('knowledge/getKnowledgeLists')
      store.dispatch('knowledge/getCategories')
    }
  })

  // 検索結果一覧が更新された時
  // 検索結果一覧エリアの表示状態をスクロール位置指定用IDの位置にスクロール
  watch(() => store.state.knowledge.lists, (newVal, oldVal) => {

    // 遷移元
    const fromName = store.state.common.fromName
    // 詳細画面から一覧画面に戻ってきた時のスクロール位置指定用ID
    const selectedListItemId = store.state.knowledge.selectedListItemId

    if (fromName === 'PCKnowledgeDetail' || fromName === 'SPKnowledgeDetail') {
      // 詳細画面から遷移してきた場合
      if (selectedListItemId === 0) {
        const scrollArea = document.getElementById('scroll-target')
        if (scrollArea) {
          scrollArea.scrollTop = 0
        }
      } else {
        // Vue.nextTick()の場合、対象htmlIdを取得できない場合がある。
        // ツリー描画に時間がかかるのではと思われる。
        // そのため、setInterval()でスクロール先要素を取得するまでループする
        let count = 0
        const intervalId = setInterval(() => {
          const htmlId = 'list-item-' + selectedListItemId
          const target = document.getElementById(htmlId)
          if (target) {
            const targetRect = target.getBoundingClientRect()
            const scrollArea = document.getElementById('scroll-target')
            if (scrollArea) {
              const areaRect = scrollArea.getBoundingClientRect()
              const scrollY = scrollArea.scrollTop + targetRect.top - areaRect.top
              scrollArea.scrollTop = scrollY
              // 詳細画面から一覧画面に戻ってきた時のスクロール位置指定用IDをクリア
              store.dispatch('knowledge/setSelectedListItemId', 0)
              clearInterval(intervalId)
            }  
          }
          count++
          if (count >= SCROLL_INTERVAL_MAX_COUNT) {
            clearInterval(intervalId)
          }
        }, SCROLL_INTERVAL_DELAY)
      }
    }
  })
  
  // 検索条件指定の配列をオブジェクトに変換
  const parseSearchParam = (searchParams) => {
    return _.fromPairs(_.map(searchParams, param => [param.key, param.value]))
  }

  const checkUpdate = (checked, value, allId) => {
    store.dispatch('knowledge/resetPagenation')
    store.dispatch('knowledge/setSeachCategory', { checked, value, allId })
  }

  const ascendigName = computed(() => {
    return store.getters['knowledge/ascendigName']
  })

  const countLists = computed(() => {
    return store.getters['knowledge/countLists']
  })

  const visible = reactive({
    detail: computed(() => {
      return knowledge.hidden_keys.find((item) => item === 'detail')
      // return !knowledge.hidden_keys || knowledge.hidden_keys.length === 0 ||
      //   knowledge.hidden_keys.find((item) => item === 'detail')
    }),
    created: computed(() => {
      return knowledge.hidden_keys.find((item) => item === 'created')
      // return !knowledge.hidden_keys || knowledge.hidden_keys.length === 0 ||
      //   knowledge.hidden_keys.find((item) => item === 'created')
    }),
    note: computed(() => {
      return knowledge.hidden_keys.find((item) => item === 'note_count')
      // return !knowledge.hidden_keys || knowledge.hidden_keys.length === 0 ||
      //   knowledge.hidden_keys.find((item) => item === 'note_count')
    }),
    category: computed(() => {
      return knowledge.hidden_keys.find((item) => item === 'knowledge_category')
      // return !knowledge.hidden_keys || knowledge.hidden_keys.length === 0 ||
      //   knowledge.hidden_keys.find((item) => item === 'knowledge_category')
    }),
    isSearch: computed(() => store.getters['knowledge/isSearch'])
  })

  const group1 = reactive({
    // 検索カテゴリ（選択肢）
    searchCategory: computed({
      get: () => {
        return store.state.search.searchCategory
      },
      set: (searchCategory) => {
        store.dispatch('search/setSearchCategory', searchCategory)
      }
    })
  })

  const clickSearch = async(options) => {

    let searchCategory
    if (
      typeof options !== 'undefined' &&
      typeof options.searchCategory !== 'undefined'
    ) {
      searchCategory = options.searchCategory
      preState.keyword = options.search_text
      preState.is_fuzzy = options.is_fuzzy
    } else {
      searchCategory = group1.searchCategory
    }

    if (group1.searchCategory !== 'knowledge') {
      // 指定した検索カテゴリに対するキーワード検索を実行し、対象の検索結果画面に遷移する
      searchByKeyword(context, searchCategory, preState.keyword, preState.is_fuzzy) 
      return
    }

    // 検索カテゴリを設定（onBeforeMountで設定されると思うが念のため設定）
    store.dispatch('search/setSearchCategory', 'knowledge')

    if (store.state.common.device === 'sp') {
      // キーワード入力欄のフォーカス表示フラグをfalseに設定
      state.isFocusInput = false
      // キーワード検索ウィンドウを閉じる
      state.visibleKnowledgeSearchByKeyword = false
    }

    await store.dispatch('knowledge/resetSearchCategory')
    await store.dispatch('knowledge/resetPagenation')
    store.dispatch('knowledge/setSearchValue', preState)
      .then(() => {
        store.dispatch('knowledge/getCategories')
        store.dispatch('knowledge/getKnowledgeLists')
      })
  }

  const preSearch = () => {
    const otherScreenSearchParams = store.getters['search/getKnowledgeSearchParam']
    if (Object.keys(otherScreenSearchParams).length > 0) {
      preState.keyword = otherScreenSearchParams.keyword ?? ''
      preState.is_fuzzy = otherScreenSearchParams.is_fuzzy ?? 0
    }
    clickSearch()
    store.dispatch('search/resetKnowledge')
  }

  /**
   * 詳細検索を実行する(SP画面で使用)
   * 用途：詳細検索ウィンドウの詳細検索実行ボタン押下時
   */
  const searchDetail = (isResetSearchCondition) => {
    // 検索一覧画面に遷移
    if (store.state.common.device === 'sp') {
      router.push({ name: 'SPQAList' })
    } else {
      router.push({ name: 'PCQAList' })
    }
  }

  const clickDateSearch = async () => {
    await store.dispatch('knowledge/resetPagenation')
    store.dispatch('knowledge/setSearchValue', preState)
      .then(() => {
        store.dispatch('knowledge/getCategories')
        store.dispatch('knowledge/getKnowledgeLists')
      })
  }

  const state = reactive({
    visibleDisplaySettings: false,
    visibleSearchOrderSettings: false,
    visibleKnowledgeSelectNote: false,
    visibleCalendar: false,
    visibleToast: false,
    isOpenMenuArrow: false,
    visibleSearchDetail: false, // 詳細検索ウィンドウ表示フラグ
    visibleMenu: false, // SP用
    visibleKnowledgeSearchExtract: false, // SP用
    visibleKnowledgeSearchByKeyword: false, // SP用
    isFocusInput: false // SP用:キーワード入力欄のフォーカス表示フラグ
  })

  const preState = reactive({
    search_date_start: knowledge.search.search_date_start,
    search_date_end: knowledge.search.search_date_end,
    is_fuzzy: '',
    keyword: ''
  })

  const searchSelect = reactive({
    isFocusInput: false,
    currentValue: 0
  })

  const calendar = reactive({
    selectedStartDate: null,
    selectedEndDate: null,
    active: null,
    inputStartDate: (date) => {
      preState.search_date_start = date
      clickDateSearch()
    },
    inputEndDate: (date) => {
      preState.search_date_end = date
      clickDateSearch()
    }
  })

  // 一覧のタイトルをクリックした場合
  const clickTitleInList = (knowledgeId) => {

    // 詳細画面から一覧画面に戻ってきた時のスクロール位置指定用ID
    store.dispatch('knowledge/setSelectedListItemId', knowledgeId)

    if (store.state.common.device === 'sp') {
      router.push({ name: 'SPKnowledgeDetail', params: { knowledgeId: knowledgeId } })
    } else {
      router.push({ name: 'PCKnowledgeDetail', params: { knowledgeId: knowledgeId } })
    }
  }

  const clickViewLater = (obj) => {
    store.dispatch('knowledge/setViewLater', obj)
  }

  const clickSaveSearchConditions = () => {

    const saveParam = ['keyword', 'search_date_start', 'search_date_end', 'is_fuzzy', 'category']
    const searchs = _.pickBy(knowledge.search, (value, key) => {
      return saveParam.includes(key) && (value !== null && value !== '')
    })
    const params = {
      title: knowledge.search.keyword ? '最新ナレッジ：' + knowledge.search.keyword : '最新ナレッジ：キーワードなし',
      key: 'knowledge',
      search: _.map(searchs, (value, key) => {
        return {
          key: key,
          value: value
        }
      })
    }
    apiSearchCondition
      .add(params)
      .then(response => {
        const data = response.data
        if (data.status === 0) {
          store.dispatch('common/showToast', { text: '検索条件を保存しました。' })
        }
      })
  }

  /**
   * 検索条件のクリア
   */
  const clickResetSearchConditions = () => {
    store
      .dispatch('knowledge/resetSearchConditions')
      .then(async () => {
        preState.search_date_start = knowledge.search.search_date_start
        preState.search_date_end = knowledge.search.search_date_end
        preState.is_fuzzy = knowledge.search.is_fuzzy
        preState.keyword = knowledge.search.keyword
        await store.dispatch('knowledge/resetPagenation')
        store.dispatch('knowledge/getCategories')
        store.dispatch('knowledge/getKnowledgeLists')
      })

    // 検索UI(PCSearchUI/SPSearchUI)の検索テキストと曖昧フラグを更新する
    store.dispatch('searchUI/setSearchInputOfSearchUI', { searchText: '', isFuzzy: 0 })
    store.dispatch('searchUI/setSearchInputOfSearchUIParam', { searchCategory: group1.searchCategory, searchText: '', isFuzzy: 0 })
  }

  const clickPageNation = async ({ currentPage, start }) => {
    await store.dispatch('knowledge/setPagenation', { currentPage, start })
    store.dispatch('knowledge/getKnowledgeLists')

    // スクロールY座標を一番上に戻す
    const scrollArea = document.getElementById('scroll-target')
    if (scrollArea) {
      scrollArea.scrollTop = 0
    }
  }

  const clickNote = async(knowledgeId) => {
    store
      .dispatch('knowledge/setKnowledgeId', knowledgeId)
      .then(() => {
        store.dispatch('knowledge/getKnowledgeNote', knowledgeId)
        state.visibleKnowledgeSelectNote = true
      })
  }

  const clickSearchHistory = () => {
    store.commit('searchHistory/setFilterTypes', ['knowledge'])
    router.push({ name: 'PCHistoryOfSearch' })
  }

  return {
    clickNote,
    clickSearch,
    preSearch,
    searchDetail,
    // menuSearch,
    group1,
    searchSelect,
    preState,
    visible,
    state,
    calendar,
    knowledge,
    formatDate,
    checkUpdate,
    ascendigName,
    countLists,
    clickTitleInList,
    clickViewLater,
    clickSaveSearchConditions,
    clickResetSearchConditions,
    clickPageNation,
    clickSearchHistory
  }
}
